import React, { useEffect, useState } from 'react';
import { 
    Box 
} from '@chakra-ui/react'
import { HomeProps } from "./types";
import Header from './components/Header/Header';
import Table from './components/Table/Table';

const Home: React.FC<HomeProps> = ({ olympInfo }) => {

    return(
        <Box>
            <Header olympInfo={olympInfo}/>
            <Table olympInfo={olympInfo} />
        </Box>
    );
}

export default Home;